<template>
  <div :class="className">
    <span
      class="right-menu-icon"
      uk-icon="icon: sign-out; ratio: 1.5"
      @click="$modal.show('logout')"
      >{{ text }}</span
    >
    <b-dialog :name="'logout'">
      <template slot="header">
        <span>Вы уверены, что хотите выйти?</span>
      </template>
      <template slot="content">
        <div class="uk-flex uk-flex-center content-action">
          <b-button name="Выйти" class="logout-button margin-right_60" @click="logout" />
          <b-button name="Отменить" color="red" @click="$modal.hide('logout')" />
        </div>
      </template>
    </b-dialog>
  </div>
</template>

<script>
export default {
  name: 'RightMenuLogoutButton',
  props: {
    text: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: true
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/LOG_OUT').finally(() => {
        this.$router.push('/login')
        this.$modal.hide('logout')
      })
    }
  }
}
</script>
